import Vue from "vue";
import Vuex from "vuex";
import service from "../../services/horarios/employees";
import employees from "../../models/horarios/employees";
import moment from "moment";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    service: new service(),
    employees: [],
    new: [],
    edit: [],
    deleteItem: [],
    showAdd: false,
    scheduleId: null,
    openEmployee: false,
    mode: "",
    openDelete: false,
  },

  mutations: {
    setEmployees(state, data) {
      state.employees = data;
    },
    setEdit(state, data) {
      state.edit = data;
    },
    setDeleteItem(state, data) {
      state.deleteItem = data;
    },
    setNew(state, data) {
      state.new = data;
    },
    setOpenEmployee(state, data) {
      state.openEmployee = data;
    },
    setScheduleId(state, data) {
      state.scheduleId = data;
    },
    setOpenDelete(state, data) {
      state.openDelete = data;
    },
    setMode(state, data) {
      state.mode = data;
    },
  },
  actions: {
    async getEmployees(state, where) {
      return new Promise(async (resolve, reject) => {
        try {
          let items = await state.state.service.getEmployees(
            state.state.scheduleId,
            where
          );

          items = items.map((item) => {
            if (item.instans && item.instans.length > 0) {
              item.instans.sort((a, b) => {
                let dateA = new Date(a.fecDesde);
                let dateB = new Date(b.fecDesde);
                return dateB - dateA;
              });
            }
            return item;
          });

          state.commit("setEmployees", items);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async edit(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.edit(state.state.edit).then(async () => {
            let data = {
              schedule: state.state.edit.schedule,
              empId: state.state.edit.id,
            };

            const employeed = await state.state.service.getEmployeedById(data);

            let options = state.state.employees;
            options = options.map((option) => {
              if (option.id === data.empId) {
                option.instans = employeed.data;
                return option;
              }
              return option;
            });

            state.commit("setEmployees", options);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },

    async new(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.new(state.state.new).then(({ data }) => {
            let item = state.state.new;
            let options = state.state.employees;
            let newItems = [];
            item.employees.forEach((id, index) => {
              if (data[index].CodError !== 1) {
                newItems.push(
                  employees.fromJson({
                    empId: id,
                    empNombre: item.names[index],
                    instancias: [
                      {
                        fecDesde: item.from,
                        fecHasta: moment
                          .utc(item.to)
                          .add(1, "days")
                          .format("YYYY-MM-DD"),
                        numSecuencia: item.sequenceNumber,
                        segmDespl: item.initialDay,
                        segmId: item.segment,
                      },
                    ],
                  })
                );
              }
            });
            options.push(...newItems);

            state.commit("setEmployees", options);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },

    async delete(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.delete(state.state.deleteItem).then(() => {
            let item = state.state.deleteItem;
            let options = state.state.employees;
            options = options.map((option) => {
              if (option.id === item.id) {
                option.instans = option.instans.filter((instancia) => {
                  return !(instancia.fecDesde === item.from + "T00:00:00.000Z");
                });
              }

              return option;
            });

            state.commit("setEmployees", options);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
});
